import SectionHeading from "@/pages/home/components/SectionHeading";
import { deepReads } from "@/mocks/analysis";

export default function DeepReads() {
  const [feature, ...rest] = deepReads;

  return (
    <section id="deep" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="02"
          eyebrow="深度解读"
          title="不急着下结论，先把脉络铺开"
          desc="把公开信息放回同一条时间轴，逐条标注出处与语境，再看谁在什么时候改变了说法。"
          actionLabel="更多深度解读"
          actionHref="#insights"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <article className="lg:col-span-7 group flex flex-col rounded-lg border border-background-200/70 bg-background-50 overflow-hidden cursor-pointer">
            <div className="relative w-full h-60 md:h-80 overflow-hidden bg-background-200">
              <img
                src={feature.image}
                alt={`${feature.title} 事件复盘拆解配图`}
                title="黑料看点 深度解读"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-4 left-4 rounded-full bg-accent-500 text-background-50 px-3 py-1 text-[11px] font-medium">
                本周主推
              </span>
            </div>
            <div className="p-5 md:p-7">
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="text-primary-700">{feature.category}</span>
                <span className="h-px w-4 bg-background-300" />
                <span>{feature.author}</span>
                <span>·</span>
                <span>{feature.readTime}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm md:text-[15px] text-foreground-500 leading-relaxed">
                {feature.summary}
              </p>
              <div className="mt-5 flex items-center justify-between text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1.5 text-secondary-700">
                  <i className="ri-bookmark-3-line" /> 收录进复盘档案
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" />
                  {feature.comments} 条讨论
                </span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-4">
            {rest.map((item) => (
              <article
                key={item.id}
                className="group flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={`${item.title} 细节分析配图`}
                    title="黑料看点 细节分析"
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-xs text-primary-600">{item.category}</span>
                  <h3 className="mt-1.5 font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.summary}
                  </p>
                  <div className="mt-auto pt-2 flex items-center gap-3 text-[11px] text-foreground-400">
                    <span>{item.author}</span>
                    <span>·</span>
                    <span>{item.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}